import Social from "../Social Icon/Social";

import "./Footer.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import Toast from "../Toast/Toast";
import ContactModal from "../../utils/modals/ContactModal";
import AboutModal from "../../utils/modals/AboutModal";
import FAQModal from "../../utils/modals/FAQModal";
import { ToastBody } from "react-bootstrap";

export default function Footer() {
  const facebook = "/facebook-brands-solid-full.svg";
const instagram = "/instagram-brands-solid-full.svg";
const whatsapp = "/whatsapp-brands-solid-full.svg";
const tiktok = "/tiktok-brands-solid-full.svg";
const twitter = "/x-twitter-brands-solid-full.svg";
  const [toasts, setToasts] = useState([]);
  const [aboutShow, setAboutShow] = useState(false);
  const [contactShow, setContactShow] = useState(false);
  const [faqShow, setFaqShow] = useState(false);


  const thisYear = new Date().getFullYear();

  const handleClick = () => {
    const newToast = {
      id: Date.now(),
      header: "Quickplanners",
      body: "Sorry, this feature is coming soon!",
    };
    setToasts([...toasts, newToast]);
  };

  const handleRemoveToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  return (
    <>
    <footer className="footer">
      <div className="footer-socials d-flex justify-content-between align-items-center">
          <div className="footer-links d-flex flex-column gap-4">
            <div className="social-icons d-flex align-items-center">
              <a href="https://wa.link/qnt5ga" target="blank">
                <Social img={whatsapp} />
              </a>

              <a href="https://www.facebook.com/Quickplannersapp" target="blank">
                <Social img={facebook} />
              </a>

              <a href="https://www.instagram.com/Quickplanners" target="blank">
                <Social img={instagram} />
              </a>

              <a href="#" target="blank">
                <Social img={tiktok} />
              </a>

              <a href="#" target="blank">
                <Social img={twitter} />
              </a>
            </div>

            <p>© {thisYear} Quickplanners. All rights reserved.</p>
        </div>
        
        <div className="footer-links d-flex flex-column gap-4">
          <div className="footer-para d-flex align-items-center">
              <p><a href="/about-us" style={{ color: 'inherit', textDecoration: 'none' }}>About us</a></p>
              <p><a href="/faq" style={{ color: 'inherit', textDecoration: 'none' }}>FAQ</a></p>
              <p><a href="/privacy-policy" style={{ color: 'inherit', textDecoration: 'none' }}>Privacy Policy</a></p>
              <p><a href="/terms-of-use" style={{ color: 'inherit', textDecoration: 'none' }}>Terms of use</a></p>
              <p><a href="/contact-us" style={{ color: 'inherit', textDecoration: 'none' }}>Contact us</a></p>
          </div>

          <p className="creator-link">Quickplanners is a product of {" "}
              <a href="https://thefoxylabs.com/" target="_blank">Foxy Labs Technology.</a> 
          </p>
        </div>
    </div>
    <Toast toasts={toasts} removeToast={handleRemoveToast} />
    </footer>
    <ContactModal contactShow={contactShow} setContactShow={setContactShow} />
    </>
  );
}
